export const reducers = {
  setIsAndroid: (state, action) => {
    state.isAndroid = action.payload;
  },
};
